import { Button, Menu, Typography, styled } from '@mui/material';

export const StyledMenu = styled(Menu)(({ theme }) => ({
  '& .MuiMenuItem-root': {
    padding: theme.spacing(0.75, 1),
    '&:not(:last-of-type)': {
      marginBottom: 0,
    },
  },
}));
export const SoundsContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(2, 1),
}));
export const SoundBoardButton = styled(Button)(({ theme }) => ({
  width: '100%',
  height: theme.spacing(4),
  minWidth: 'unset',
  gap: 4,
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  '& .iconConfig:not(.active)': {
    display: 'none',
  },
  '&:hover': {
    boxShadow: 'none',
    '& .iconConfig': {
      display: 'inline-flex',
    },
  },
  '& .iconConfig': {
    width: theme.spacing(3),
    height: theme.spacing(3),
    padding: theme.spacing(0.5),
  },
  [theme.breakpoints.up('md')]: {
    width: '100%',
    height: 40,
  },
}));
export const StyledTextItem = styled(Typography)(({ theme }) => ({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  textWrap: 'nowrap',
  whiteSpace: 'nowrap',
}));
